export default __webpack_public_path__ + "static/media/icon_9.ece59ba3.png";